/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    countries: {
        menu: {
            index: 'کشورها',
            create: 'کشور جدید',
            list: 'کشورها'
        },
        table_titles: {
            id: 'شناسه',
            name: 'نام',
            acronym: 'مخفف دو حرفی',
            acronym3: 'مخفف سه حرفی',
            calling_code: 'کد تماس',
            currency_acronym: 'ارز',
            reward_amount_of_new_user: 'مقدار پاداش کاربر جدید',
            reward_amount_of_old_user: 'مقدار پاداش کاربر قدیمی',
            reward_min_transfer_amount: 'حداقل مبلغ انتقال برای پاداش',
            currency: 'ارز',
            is_for_secondary_currency: "ارز ثانویه",
            has_acceptable_id_document: "مدرک شناسایی پذیرفته شده",
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش کشور'
    }
}

